import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

const PROD = true;
const BASE_URL = PROD ? 'https://us-central1-orb-ai-project.cloudfunctions.net/api' : 'http://127.0.0.1:5001/orb-ai-project/us-central1/api';

/**
 * Helper function to handle API requests.
 */
const apiRequest = async (url, method, body = null, auth = true) => {
  var headers = {
    'Content-Type': 'application/json',
  }
  if (!auth) {
    setPersistence(getAuth(), browserLocalPersistence)
      .then(() => {
        // Existing and future sign-in sessions now persisted in local storage
        console.log('storage set')
      })
      .catch((error) => {
        // Handle Errors here.
        console.log('storage failed:', error)
      });
  } else if (auth) {
    const user = getAuth().currentUser;

    if (!user) {
        throw new Error("User is not signed in");
    }

    const idToken = await user.getIdToken();
    headers = {
      'Content-Type': 'application/json',
      "Authorization": `Bearer ${idToken}`,
    };
  }

  const options = {
    method,
    headers,
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(`${BASE_URL}${url}`, options);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'API request failed');
  }

  console.log('response', response)
  return response.json();
};

export const createUser = async (body) => {
  return apiRequest('/user', 'POST', body, false);
};

export const generateChart = async () => {
  return apiRequest('/planets/generate', 'POST', {});
};

export const fetchChart = async () => {
  return apiRequest('/chart', 'GET');
};